/* eslint-disable camelcase */
/* eslint-disable complexity */
import {useMemo} from 'react';

import * as store from '@/store';
import {recognizeLinks, IRecognizeLinksOptions} from '@/utils/document/flow';

/**
 * 链接转换配置
 *
 * @param options 配置对象
 * @param options.docGuid 文档的唯一标识符，默认为空字符串
 * @param options.inBottomComment 是否在底部评论中识别链接，默认为 false，底部评论目前仅支持 mention 类型识别
 */
export const useLinkTransformConfig = ({
    docGuid = '', inBottomComment = false,
}: {
    docGuid?: string; inBottomComment?: boolean;
} = {}) => {
    return useMemo(() => {
        const recognizeLinksWrapper = async (urls: string[], options?: IRecognizeLinksOptions) => {
            return recognizeLinks({
                docGuid: docGuid || store.getData(store.KEYS.CUR_DOCUMENT)?.docGuid || '',
                urls,
                options: inBottomComment ? {type: 'mention', from: options?.from} : options,
            });
        };

        return {
            recognizeLinks: recognizeLinksWrapper,
        };
    }, [docGuid, inBottomComment]);
};
